import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=01debdfa&scoped=true"
import script from "./PopupBox.vue?vue&type=script&lang=js"
export * from "./PopupBox.vue?vue&type=script&lang=js"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=01debdfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01debdfa",
  null
  
)

export default component.exports